import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource } from 'app/model/pipeline/copysource/azure-data-lake-store-gen2-cosmos-structured-stream.copysource';
import { ValueAdapter } from '../../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts
    }
})
export class AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySourceAdapter extends CopySourceAdapter<
    AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource,
    Model.AzureDataLakeStoreGen2CosmosStructuredStreamSource
> {
    protected override async _toResource(
        copySource: AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource
    ): Promise<Model.AzureDataLakeStoreGen2CosmosStructuredStreamSource> {
        const result: Model.AzureDataLakeStoreGen2CosmosStructuredStreamSource = this.getCommonCopySourceProperties(
            copySource,
            'AzureDataLakeStoreGen2CosmosStructuredStreamSource'
        );
        result.partitionIndex = ValueAdapter.toResource(
            copySource,
            AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource.PARTITION_INDEX
        );
        return result;
    }

    protected override async _toModel(
        adlsGen2CosmosStructuredStreamSource: Model.AzureDataLakeStoreGen2CosmosStructuredStreamSource,
        copyActivity: CopyActivity
    ): Promise<AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource.MODEL,
            adlsGen2CosmosStructuredStreamSource,
            copyActivity
        ) as AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource;
        ValueAdapter.toModel(
            result,
            AzureDataLakeStoreGen2CosmosStructuredStreamFileCopySource.PARTITION_INDEX,
            adlsGen2CosmosStructuredStreamSource.partitionIndex
        );
        return result;
    }
}
